export default __webpack_public_path__ + "static/media/039-boot.5c37df90.svg";